import { combineEpics } from 'redux-observable';
import { EMPTY, Observable } from 'rxjs';
import { filter, pairwise, switchMap, withLatestFrom } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';

import { GlobalAppActions, routeChangeAction } from 'rdx/actions';
import { AppServices } from 'rdx/middleware';
import { GlobalAppState } from 'rdx/state';

const refreshOnRouteChangeIfApplicationUpdatedEpic = (
  action$: Observable<GlobalAppActions>,
  _: Observable<GlobalAppState>,
  { applicationUpdateService }: AppServices,
): Observable<GlobalAppActions> => {
  return action$.pipe(
    filter(isActionOf(routeChangeAction)),
    pairwise(),
    withLatestFrom(applicationUpdateService.applicationUpdateSubject$),
    filter(
      ([[previousAction, newAction], applicationUpdateRef]) =>
        previousAction.payload.location.pathname !== newAction.payload.location.pathname &&
        applicationUpdateRef?.hasUpdate,
    ),
    switchMap(([[, action]]) => {
      const search = new URLSearchParams(action.payload.location.search);

      search.set('ts', String(Date.now()));

      window.location.replace(`${action.payload.location.pathname}?${search.toString()}`);

      return EMPTY;
    }),
  );
};

export const applicationEpic = combineEpics(refreshOnRouteChangeIfApplicationUpdatedEpic);
